import { Link } from "react-router-dom";

const BenefitsOfTravelingInALuxurySprinterVan = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Fleet & Vehicles
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            Benefits Of Traveling In A Luxury Sprinter Van
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>June 18, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">

                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/veloxcharter-blog-1.png"
                                    alt="Luxury Sprinter Van"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">

                                    <p className="text-[#666666] leading-8 text-lg">
                                        Luxury Sprinter Vans have become one of
                                        the most popular transportation options
                                        for business travelers, event organizers,
                                        families, and private groups. Combining
                                        comfort, flexibility, and modern
                                        amenities, these vehicles offer a premium
                                        travel experience that bridges the gap
                                        between executive transportation and
                                        full-size charter buses.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        Whether you're planning an airport
                                        transfer, corporate event, wedding,
                                        sporting event, or private group outing,
                                        a luxury Sprinter Van delivers a level
                                        of comfort and convenience that standard
                                        transportation options simply can't match.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Exceptional Passenger Comfort
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            One of the biggest advantages of a
                                            luxury Sprinter Van is passenger
                                            comfort. Spacious seating, generous
                                            legroom, and premium interiors create
                                            a relaxing environment for both short
                                            and long-distance travel.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Plush Seating</li>
                                            <li>✓ Spacious Interiors</li>
                                            <li>✓ Comfortable Legroom</li>
                                            <li>✓ Smooth Ride Experience</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Perfect For Small & Medium Groups
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Sprinter Vans are ideal for groups
                                            that are too large for SUVs but do
                                            not require a full-size charter bus.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Corporate Teams",
                                                "Airport Groups",
                                                "Wedding Parties",
                                                "Family Gatherings",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Modern Amenities
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Today's luxury Sprinter Vans are
                                            equipped with modern amenities
                                            designed to improve the passenger
                                            experience.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ USB Charging Ports</li>
                                            <li>✓ Climate Control</li>
                                            <li>✓ Premium Lighting</li>
                                            <li>✓ Tinted Privacy Windows</li>
                                            <li>✓ Spacious Luggage Storage</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Ideal For Airport Transportation
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Airport transportation requires a
                                            vehicle that can comfortably
                                            accommodate both passengers and
                                            luggage. Sprinter Vans offer the
                                            perfect balance of seating capacity
                                            and storage space.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Whether you're traveling with
                                            colleagues, family, or clients,
                                            airport transfers become much more
                                            convenient with a luxury Sprinter Van.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Professional Image
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Luxury transportation creates a
                                            positive impression. Businesses
                                            frequently choose Sprinter Vans for
                                            executive travel, client pickups,
                                            conferences, and corporate events.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Arriving in a professionally
                                            maintained luxury vehicle helps
                                            reinforce professionalism and
                                            attention to detail.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Safe & Reliable Transportation
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Safety is always a priority. Modern
                                            Sprinter Vans are equipped with
                                            advanced safety systems and are
                                            regularly maintained to ensure a
                                            dependable transportation experience.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Advanced Safety Features</li>
                                            <li>✓ Routine Inspections</li>
                                            <li>✓ Professional Drivers</li>
                                            <li>✓ Reliable Scheduling</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Cost-Effective Group Travel
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Rather than coordinating multiple
                                            vehicles, a luxury Sprinter Van keeps
                                            your group together while helping
                                            reduce transportation costs and
                                            simplify logistics.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            This makes Sprinter Vans an excellent
                                            value for businesses, event planners,
                                            and private groups.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Luxury Sprinter Vans offer an ideal
                                            combination of comfort, convenience,
                                            safety, and flexibility. Whether
                                            you're planning airport transfers,
                                            corporate travel, weddings, or group
                                            transportation, these vehicles
                                            provide a premium experience for
                                            every passenger.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            At Velox Charter, our luxury Sprinter
                                            Vans are designed to deliver reliable
                                            and professional transportation
                                            solutions tailored to your travel
                                            needs.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="lg:col-span-4">

                            <div className="sticky top-6">

                                <div className="bg-primary rounded-[24px] p-8 text-center">

                                    <h3 className="text-white text-2xl font-semibold">
                                        Need A Luxury Sprinter Van?
                                    </h3>

                                    <p className="mt-4 text-white/80 leading-7">
                                        Our premium Sprinter Vans are perfect
                                        for airport transfers, corporate travel,
                                        weddings, and private group
                                        transportation.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>
                                </div>

                                <div className="bg-white rounded-[24px] p-8 mt-8">

                                    <h3 className="text-2xl font-semibold">
                                        Why Travelers Love Sprinter Vans
                                    </h3>

                                    <div className="mt-6 space-y-4 text-[#666666]">
                                        <p>✓ Luxury Seating</p>
                                        <p>✓ Extra Legroom</p>
                                        <p>✓ Large Luggage Capacity</p>
                                        <p>✓ Professional Chauffeurs</p>
                                        <p>✓ Ideal For Group Travel</p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </section>
    );
};

export default BenefitsOfTravelingInALuxurySprinterVan;